import { api } from "./api";

export interface Category {
  id: string;
  name: string;
  description?: string | null;
  displayOrder: number;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateCategoryData {
  name: string;
  description?: string;
  displayOrder: number;
  isActive?: boolean;
}

export interface UpdateCategoryData extends Partial<CreateCategoryData> {}

export const categoryService = {
  async getAll(): Promise<Category[]> {
    const response = await api.get<{ success: boolean; data: Category[] }>(
      "/categories",
    );
    return response.data?.data ?? [];
  },

  async getById(id: string): Promise<Category> {
    const response = await api.get<{ success: boolean; data: Category }>(
      `/categories/${id}`,
    );
    if (!response.data?.data) throw new Error("Catégorie introuvable");
    return response.data.data;
  },

  async create(data: CreateCategoryData): Promise<Category> {
    const response = await api.post<{ success: boolean; data: Category }>(
      "/categories",
      data,
    );
    if (!response.data?.data) throw new Error("Création de catégorie échouée");
    return response.data.data;
  },

  async update(id: string, data: UpdateCategoryData): Promise<Category> {
    const response = await api.put<{ success: boolean; data: Category }>(
      `/categories/${id}`,
      data,
    );
    if (!response.data?.data) throw new Error("Mise à jour de catégorie échouée");
    return response.data.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/categories/${id}`);
  },
};
